// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;

export const ErrorResponseCode = {
  NOT_FOUND: "NOT_FOUND",
  VALIDATION: "VALIDATION",
  LOGIC: "LOGIC",
  PERMISSION_ACCESS: "PERMISSION_ACCESS",
  ALREADY_UPDATED: "ALREADY_UPDATED",
  MESSAGE: "MESSAGE",
};

// Роли пользователей
export const RoleCode = {
  ADMIN: "admin",
  EMPLOYEE: "employee",
};

// Конфигурация бокового меню для ролей
export const RoleMenu = {
  employee: [
    {
      group: "MainPages",
      rows: ["ApprovalRequest", "Organization"],
    },
  ],
};

// Конфигурация верхнего меню (header)
export const RoleMenuHeader = {
  employee: [
    {
      group: "MainPages",
      rows: ["ApprovalRequest", "Organization"],
    },
  ],
};